export default __webpack_public_path__ + "static/media/e-ppt-logotype-d.d7d177ee.svg";